import React, { useState, useEffect } from 'react';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

function PinSetup({ onDone }) {
  const [step, setStep] = useState(1);
  const [pin1, setPin1] = useState('');
  const [pin2, setPin2] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key >= '0' && e.key <= '9') handleKey(e.key);
      if (e.key === 'Backspace') handleDel();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  });

  const handleKey = (n) => {
    if (step === 1) {
      if (pin1.length >= 8) return;
      const newPin = pin1 + n;
      setPin1(newPin);
      if (newPin.length === 8) setTimeout(() => setStep(2), 300);
    } else {
      if (pin2.length >= 8) return;
      const newPin = pin2 + n;
      setPin2(newPin);
      if (newPin.length === 8) {
        setTimeout(async () => {
          if (newPin === pin1) {
            try {
              await setDoc(doc(db, 'users', auth.currentUser.uid), {
                pin: pin1,
                createdAt: new Date()
              }, { merge: true });
              setStep(3);
            } catch (e) {
              setError('Error saving PIN. Try again.');
            }
          } else {
            setError('PINs do not match — try again');
            setPin2('');
          }
        }, 200);
      }
    }
  };

  const handleDel = () => {
    if (step === 1) setPin1(pin1.slice(0, -1));
    else setPin2(pin2.slice(0, -1));
    setError('');
  };

  const Dots = ({ value }) => (
    <div className="flex justify-center gap-2 mb-2">
      {[...Array(8)].map((_, i) => (
        <div key={i} className={`w-3 h-3 rounded-full border-2 transition-all ${
          i < value.length ? 'bg-yellow-400 border-yellow-400' : 'border-gray-600'
        }`} />
      ))}
    </div>
  );

  const KeyPad = () => (
    <div className="grid grid-cols-3 gap-2 mt-3">
      {[1,2,3,4,5,6,7,8,9].map(n => (
        <button key={n} onClick={() => handleKey(String(n))}
          className="py-3 bg-gray-800 border border-gray-700 rounded-lg text-white font-medium hover:bg-gray-700 active:scale-95 transition-all">
          {n}
        </button>
      ))}
      <div></div>
      <button onClick={() => handleKey('0')}
        className="py-3 bg-gray-800 border border-gray-700 rounded-lg text-white font-medium hover:bg-gray-700 active:scale-95 transition-all">
        0
      </button>
      <button onClick={handleDel}
        className="py-3 bg-gray-800 border border-gray-700 rounded-lg text-gray-400 hover:bg-gray-700 active:scale-95 transition-all text-sm">
        ⌫
      </button>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-5">
      <div className="bg-gray-900 border border-gray-800 rounded-2xl p-7 w-72 text-center">

        <svg width="40" height="40" viewBox="0 0 100 130" fill="none" className="mx-auto mb-4">
          <defs>
            <linearGradient id="pg" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#f2c832"/>
              <stop offset="100%" stopColor="#e8496a"/>
            </linearGradient>
          </defs>
          <path d="M58 4L84 4L84 10L68 10L68 54L84 54L84 62L52 126L42 126L62 72L44 72L44 62L16 62L16 54L32 54L32 10L16 10L16 4L42 4L42 54L58 54Z" fill="url(#pg)"/>
        </svg>

        {step === 1 && (
          <>
            <h2 className="text-lg font-bold text-white mb-1">Create PIN</h2>
            <p className="text-xs text-gray-500 mb-4">8-digit PIN · click or use keyboard</p>
            <Dots value={pin1} />
            <p className="text-xs text-gray-600 mb-2">{pin1.length} / 8</p>
            <KeyPad />
          </>
        )}

        {step === 2 && (
          <>
            <h2 className="text-lg font-bold text-white mb-1">Confirm PIN</h2>
            <p className="text-xs text-gray-500 mb-4">Enter your PIN again</p>
            <Dots value={pin2} />
            {error && <p className="text-xs text-red-400 mb-2">{error}</p>}
            <KeyPad />
          </>
        )}

        {step === 3 && (
          <>
            <div className="text-4xl text-green-400 mb-3">✓</div>
            <h2 className="text-lg font-bold text-white mb-1">PIN created!</h2>
            <p className="text-xs text-gray-500 mb-5">Your account is secured</p>
            <button onClick={onDone}
              className="w-full bg-gradient-to-r from-yellow-500 to-pink-600 text-white font-semibold py-2.5 rounded-lg text-sm hover:opacity-90 transition-all">
              Enter ArcBolt →
            </button>
          </>
        )}

      </div>
    </div>
  );
}

export default PinSetup;